<template>
  <div class="container float-left">
    <h5 class="text-center">🔔 我的通知</h5>
    <hr />
    <div v-if="data">
      <div v-if="data.length > 0" @click="markNotificationRead">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :total="this.total"
          :page-size="this.size"
          :hide-on-single-page="true"
        >
        </el-pagination>
        <div
          v-for="notification in data"
          :key="notification.id"
          class="each-reply row"
        >
          <div
            class="col-md-11"
            v-if="notification.type === 'App\\Notifications\\TopicReplied'"
          >
            <div class="media-heading">
              <el-avatar
                class="alignAvatar"
                size="small"
                fit="cover"
                alt="用户图片"
              >
                <img
                  loading="lazy"
                  title="用户图片"
                  alt="用户图片"
                  :src="notification.data.user_avatar"
                />
              </el-avatar>
              <router-link :to="'/users/' + notification.data.user_id">
                {{ notification.data.user_name }}
              </router-link>
              评论了
              <a :href="notification.data.topic_link" target="_blank">
                {{ notification.data.topic_title }}
              </a>

              <!--回复删除按钮-->
              <span class="float-right" :title="notification.created_at">
                🕒
                {{ notification.created_at }}
              </span>
            </div>
            <el-card>
              <div v-html="notification.data.reply_content"></div>
            </el-card>
          </div>
          <div
            class="col-md-11"
            v-if="notification.type === 'App\\Notifications\\AddPin'"
          >
            <div class="media-heading">
              📌 置顶

              <!--回复删除按钮-->
              <span class="float-right" :title="notification.created_at">
                🕒
                {{ notification.created_at }}
              </span>
            </div>
            <el-card>
              <div>
                恭喜您，获得置顶{{
                  notification.data.count
                }}个，每个置顶可以把每个话题置顶24小时。
              </div>
            </el-card>
          </div>
          <div class="col-md-1">
            <font-awesome-icon
              size="lg"
              v-if="notification.read_at == null"
              :style="{ color: 'red' }"
              title="未读"
              icon="envelope"
              pull="left"
            />
            <font-awesome-icon
              size="lg"
              v-else
              :style="{ color: 'gray' }"
              title="已读"
              icon="envelope-open"
              pull="left"
            />
          </div>
        </div>
        <el-pagination
          :current-page.sync="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="this.total"
          :page-size="this.size"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
      <div v-else>没有消息通知！</div>
    </div>
    <div v-else class="text-center">
      <i class="el-icon-loading" style="font-size:30px"></i>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      data: "",
      // pagination related
      total: 0,
      size: 20,
      currentPage: 1
    };
  },
  props: ["id"],
  computed: {
    ...mapState(["user"])
  },
  watch: {
    "user.notification_count": function() {
      this.fetchNotifications();
    },
    // pagination related
    currentPage: function() {
      this.fetchNotifications();
    }
  },
  methods: {
    fetchNotifications: function() {
      this.$http
        // pagination related
        .get(`/notifications?page=${this.currentPage}`)
        .then(res => {
          this.data = res.data.data;
          this.total = res.data.meta.pagination.total;
          this.size = res.data.meta.pagination.per_page;
        });
    },
    markNotificationRead: function() {
      this.$http.patch(`/notifications/read`).then(() => {
        if (this.user) {
          this.user.notification_count = 0;
        }
      });
    }
  },
  // set the layout to user when it's mounted.
  mounted: function() {
    this.fetchNotifications();
  },
  beforeDestroy: function() {
    this.$http.get(`/notifications/unread`).then(res => {
      if (res.data.unread_count <= this.currentPage * this.size) {
        this.markNotificationRead();
      }
    });
  }
};
</script>

<style scoped>
.each-reply {
  margin-top: 15px;
  overflow: hidden;
  width: 100%;
}
</style>
